import { Button, type ButtonProps } from '@mantine/core';
import { createLink } from '@tanstack/react-router';
import { forwardRef, type MouseEventHandler } from 'react';

type MantineLinkButtonProps = Omit<ButtonProps, 'href'> & {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const MantineLinkButton = forwardRef<HTMLAnchorElement, MantineLinkButtonProps>((props, ref) => (
  <Button component="a" ref={ref} {...props} />
));

MantineLinkButton.displayName = 'MantineLinkButton';

export const LinkButton = createLink(MantineLinkButton);
